import { createMuiTheme } from '@material-ui/core/styles';

const blue1 = '#0090E5';
const blue2 = '#7AC5F1';
const blue3 = '#A2DCFF';
const blue4 = '#DAEFFB';

const black = '#1B1A1A';
const red = '#DE5753';

const darkGrey = '#555555';
const grey = '#9EA8AB';
export const successColor = '#00B67A';

export const maxContainerWidth = 1300;

export const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      md: 768,
      lg: 1366,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: blue1,
      contrastText: blue2,
      dark: blue3,
      light: blue4,
    },
    error: {
      main: red,
    },
    grey: {
      main: grey,
      dark: darkGrey,
    },
    black: {
      main: black,
    },
    success: {
      main: successColor,
    },
  },

  typography: {
    fontFamily: 'IBM Plex Sans',
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '2px',
        height: '45px',
        fontSize: '16px',
        lineHeight: '16px',
        fontWeight: 'bold',
        textTransform: 'unset',
      },
      containedPrimary: {
        color: 'white',
        boxSizing: 'border-box',
        border: '1px solid transparent',
        boxShadow: 'unset',
        backgroundColor: '#4A9EDB',
        '&:hover': {
          backgroundColor: '#00A0FF',
          border: '1px solid rgba(17, 17, 17, 0.12)',
        },
        '&:focus': {
          backgroundColor: '#0083D1',
          border: '1px solid rgba(17, 17, 17, 0.12)',
        },
        '&:active': {
          backgroundColor: '#0083D1',
          border: '1px solid rgba(17, 17, 17, 0.12)',
        },
      },
      outlinedPrimary: {
        fontWeight: 500,
      },
      text: {
        contained: {
          color: 'white',
        },
      },
      sizeSmall: {
        height: '30px',
      },
    },
  },
});
